import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { SoftwareAdminApi, type SoftwareStatus } from 'openapi'

export const useSoftwareAdminList = (params: {
  offset?: number
  limit: number
  status?: SoftwareStatus
  ordering: string
  query?: string
}) => {
  const { offset, limit, ordering, query, status } = params

  return useQuery({
    queryKey: ['SoftwareAdminApi.list', limit, offset, status, ordering, query],
    queryFn: async () => {
      return SoftwareAdminApi.list({ limit, offset, status, ordering, query })
    },
    placeholderData: keepPreviousData,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
  })
}
